"use client"

import { Columns3 } from "lucide-react"
import { component, Icon } from "../icon"

/**
 * `Columns3Icon` is [Lucide](https://lucide.dev) SVG icon component.
 *
 * @see https://yamada-ui.com/docs/components/icon
 */
export const Columns3Icon = component(Icon)({ as: Columns3 })
